import { makeAutoObservable } from "mobx"
import Action from "./Action"
import CampaignScenarioActionGroup from "./CampaignScenarioActionGroup"
import CampaignScenariosProjectAsset from "./CampaignScenariosProjectAsset"

export default class CampaignScenario {

  constructor(campaignScenario = {}) {
    this.id = campaignScenario.id
    this.name = campaignScenario.name
    this.is_visible = !!campaignScenario.is_visible
    this.timeline_visible = !!campaignScenario.timeline_visible
    this.active = campaignScenario.active !== undefined ? !!campaignScenario.active : true
    this.budget_table_column_visibility = campaignScenario.budget_table_column_visibility || {}
    this.advertiser_margin = campaignScenario.advertiser_margin
    this.influencer_payout_margin = campaignScenario.influencer_payout_margin
    this.campaign_id = campaignScenario.campaign_id
    this.is_selected = campaignScenario.is_selected
    this.actions = campaignScenario.actions?.map(action => new Action(action)) || []
    this.campaign_scenario_action_groups = campaignScenario.campaign_scenario_action_groups?.map(campaignScenarioActionGroup => new CampaignScenarioActionGroup(campaignScenarioActionGroup)) || []
    this.campaign_scenarios_project_assets = campaignScenario.campaign_scenarios_project_assets?.map(campaignScenariosProjectAsset => new CampaignScenariosProjectAsset(campaignScenariosProjectAsset))
    this.campaign_custom_field_values = campaignScenario.campaign_custom_field_values || []

    makeAutoObservable(this)
  }
}
